import LocalAsyncStore from '../../local-async-store'
import SessionDetails from './views'
import { apiEndPoint } from './helpers'

export default LocalAsyncStore('session_reports', SessionDetails, apiEndPoint)



// WEBPACK FOOTER //
// ./src/session-summaries/details/index.js